import { defineEndpoints } from '../config/define-endpoints';

import { BeehiivPublicationIds } from './constants';
import { GetBlastsRequest, GetBlastsResponse } from './models/blasts.model';
import { GetPostsResponse } from './models/posts.model';
import { BeehiivBlast, BeehiivPost, Content, ContentEmail } from './models/shared.model';

const SERVERSIDE_BEEHIIV_ENDPOINTS = defineEndpoints(template => ({
    GET: {
        BLASTS: template(`/publications/{publicationId}/email_blasts`),
        POST: template(`/publications/{publicationId}/posts/{postId}`),
        POSTS: template(`/publications/{publicationId}/posts`),
        PUBLICATIONS: template(`/publications`),
        SUBSCRIPTION_BY_EMAIL: template(`/publications/{publicationId}/subscriptions/by_email/{email}`),
    },
    POST: {
        SUBSCRIBE_BEEHIIV: template(`/publications/{publicationId}/subscriptions`),
    },
    PUT: {
        UPDATE_SUBSCRIPTION: template(`/publications/{publicationId}/subscriptions/{subscriptionId}`),
    },
}));

export type { BeehiivBlast, BeehiivPost, Content, ContentEmail, GetBlastsRequest, GetBlastsResponse, GetPostsResponse };
export { BeehiivPublicationIds, SERVERSIDE_BEEHIIV_ENDPOINTS };
